import './ContactLinks.css';
import Modal from '../../../Pages/ModalForm';
import React, { useState, useRef } from 'react';
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";

const ContactLinks = () => {
    const [showModal, setShowModal] = useState(false);

    const tawkMessengerRef = useRef();

    // const handleShow = () => {
    //     setShowModal(true);
    // }

    const handleShow = () => {
        // Open the chatbot using the Tawk Messenger instance
        if (tawkMessengerRef.current) {
            tawkMessengerRef.current.maximize();
        }
    };

    const handleClose = () => setShowModal(false);
    return (
        <>
            {/* Tawk Messenger Component */}
            <TawkMessengerReact
                propertyId="629466b9b0d10b6f3e74adf9"
                widgetId="1g49r2i4m"
                ref={tawkMessengerRef}
            />

            <div className=" container busy-executive-section px-md-5 mb-md-5 mb-3 mt-5 mt-1">

                <div className="row">
                    <div className="col-md-12 mt-md-5 mt-1 px-lg-2">
                        <h1 className="headings"><span>Hey,</span> Busy Executives! </h1>
                        <p className="contact-link-subtxt mt-3 pb-2 grotesk-headings"><b>Stressed</b> about planning your next business trip? Let Blueberry Travel turn your travel chaos into a flawless business journey. We handle everything from scheduling meetings to booking flights and accommodation, so you can only focus on your business.

                        </p>
                        <p className="links-secondP grotesk-headings">Connect with our team today and experience hassle-free business travel like never before!</p>
                    </div>
                </div>


            </div>
            <div className="second-part mb-md-5 d-flex flex-column justify-content-center">
                <div className="container">
                    <div className="row mb-1">
                        <div className="col-md-2 col-xxl-4 mt-3"></div>
                        <div className="col-md-10 col-xxl-8 mt-md-3 d-flex justify-content-center">
                            <div className="box-1 box position-relative p-2">
                                <div className="text">
                                    <h2 className="headings mt-md-2 mb-1">Request a Call</h2>
                                    <p className=" mt-xxl-3 mt-md-2 box1-innertext mb-1">We’re here for you from sunrise to sunset—and beyond! Share your details, and we’ll give you a call to address all your queries with a smile.</p>
                                    <a
                                        href="tel:+97147707355"
                                        className="btn btn-light bg-transparent border-0 outline-0 text-uppercase click-fs fw-bold ps-0"
                                    >
                                        <span>CLICK HERE</span>
                                    </a>


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-1">
                        <div className="col-md-10 col-xxl-8 mt-md-3 d-flex justify-content-center">
                            <div className="box-2 box position-relative p-2 mt-3">
                                <div className="text-2 w-75 ps-3 ps-md-4">
                                    <h2 className="headings mt-md-2 mb-1">Send Us a Message</h2>
                                    <p className=" mt-xxl-3 mt-md-2 box1-innertext mb-1">Got feedback or a suggestion? Drop a detailed message addressing your views, and we’ll get back to you within 24 hours. Your input matters, and we’re here to help!</p>

                                    <button className="btn btn-light bg-transparent border-0 outline-0 text-uppercase click-fs fw-bold ps-0"
                                        type="submit" onClick={handleShow}><span>CLICK HERE</span>
                                    </button>

                                    <Modal show={showModal} handleClose={handleClose} />
                                    <div id="modal-placeholder"></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2 col-xxl-4 mt-md-3"></div>
                    </div>

                    <div className="row mb-1">
                        <div className="col-md-2 col-xxl-4 mt-3"></div>
                        <div className="col-md-10 col-xxl-8 mt-md-3 d-flex justify-content-center">
                            <div className="box-3 box position-relative p-2 mt-3">
                                <div className="text">
                                    <h2 className="headings mt-md-2 mb-1 ">Connect with Customer Care</h2>
                                    <p className=" mt-xxl-3 mt-md-2 box1-innertext mb-1">Need assistance right away? Reach out to our customer team now! They will handle your queries personally and ensure a quick resolution.
                                    </p>
                                    <a
                                        href="https://wa.me/919251655411"
                                        className="btn btn-light bg-transparent border-0 outline-0 text-uppercase click-fs fw-bold ps-0"
                                    >
                                        <span>click here</span>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactLinks